import { render, staticRenderFns } from "./RELHistoricoRoteirizacao.vue?vue&type=template&id=12a512a2&scoped=true&"
import script from "./RELHistoricoRoteirizacao.vue?vue&type=script&lang=js&"
export * from "./RELHistoricoRoteirizacao.vue?vue&type=script&lang=js&"
import style0 from "./RELHistoricoRoteirizacao.vue?vue&type=style&index=0&id=12a512a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a512a2",
  null
  
)

export default component.exports